export default __webpack_public_path__ + "static/media/kristen-kaethler-vaGL6AJkUb4-unsplash.cc3b7fe4.jpg";